module.exports = __webpack_public_path__ + "img/20200912_131214.e651aab6.jpg";